import React from 'react';
import { Col, Row } from 'antd';
import { Button, MenuItem, Select } from '@material-ui/core';

const RegisterDomainInput = (props) => {
  const { name, setName, availableTld, tld, setTld, onSearch, isButtonEnabled } = props;
  return (
    <div
      style={{
        background: '#FCFCFC',
        borderRadius: '8px',
        boxShadow:
          '0px 2px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08)',
        height: '56px'
      }}
    >
      <Row justify="center" style={{ height: '100%' }}>
        <Col
          span={15}
          style={{
            borderRight: '1px solid #D6D8E7'
          }}
        >
          <input
            onChange={setName}
            style={{
              border: 0,
              color: '#14142B',
              fontSize: '16px',
              height: '100%',
              marginLeft: '16px',
              marginRight: '16px',
              outline: 0,
              width: '90%'
            }}
            value={name}
          />
        </Col>
        <Col span={5}>
          <Select
            disableUnderline
            id="demo-simple-select"
            labelId="demo-simple-select-label"
            onChange={setTld}
            style={{
              height: '100%',
              textAlign: 'left',
              width: '90%'
            }}
            value={tld}
          >
            {availableTld.map((tld, index) => {
              return (
                <MenuItem key={index} value={tld}>
                  {tld}
                </MenuItem>
              );
            })}
          </Select>
        </Col>
        <Col span={4}>
          <Button
            disabled={!isButtonEnabled}
            onClick={onSearch}
            style={{
              backgroundColor: '#5564F8',
              borderBottomLeftRadius: '0px',
              borderTopLeftRadius: '0px',
              color: 'white',
              height: '100%',
              width: '100%'
            }}
          >
            Search
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default RegisterDomainInput;
